document.addEventListener('DOMContentLoaded', () => {
    const input1 = document.getElementById('preview-input-1');
    const input2 = document.getElementById('preview-input-2');
    const preview1 = document.getElementById('preview-line-1');
    const preview2 = document.getElementById('preview-line-2');

    if (input1 && preview1) {
        input1.addEventListener('input', () => {
            preview1.textContent = input1.value.toUpperCase() || 'YOUR DOG';
        });
    }

    if (input2 && preview2) {
        input2.addEventListener('input', () => {
            preview2.textContent = input2.value || '555-019-8372';
        });
    }
});
